import { useEffect, useState } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import BiggerAdvantage from "../assets/Aakash_Advantage_2024.png";
// import IATBiggerAdvantage from "../assets/Aakash_Advantage_IAT.png";
import IATBiggerAdvantage from "../assets/Aakash_Advantage_IAT_NEW.jpg";
import IAT_OUTSTANDING from "../assets/Aakash_IAT_NEW.jpg";
import AKTHEBiggerAdvantage from "../assets/Akthe_Advantage_2025.png";
import iACSTBiggerAdvantage from "../assets/Akthe_Advantage_2026.jpg";
import ResultGraph from "../assets/outstanding_2024.png";
import IATResultGraph from "../assets/IAT_outstanding_jee_2026.jpg"
import AktheOustandingresult from "../assets/Akthe_outstanding_result_2025.png"
import AktheOustandingresultAdv from "../assets/Akthe_outstanding_result_adv_2025.png"
import AktheOlympiads1 from "../assets/Akthe_Aakashians_olympiads_2025.png"
import Olympiads from "../assets/olympiadframe-2024.png";
import IATOlympiads from "../assets/IAT_Olypiads-result_2026.jpg"
import AktheOlympiads2 from "../assets/AKTHE_Olympiads2_2025.png"
import AntheTripWinner from "../assets/anthe-trip-2024.png";
import AKTHETripWinner from "../assets/Akthe_hall_of_fame.png"
// import Response from "./response.json";
import AntheResultPage1_Qualified from "./AntheResultPage1_Qualified";
import RelativePerformanceTable from "./RelativePerformanceTable";
import AntheComplexTable from "./Result/AntheResults/resultTable/complexity-analysis-table";
import CashAwards from "../assets/cash-award-2025.png";
import AKTHECashAward from "../assets/Akthe_cashawards_2025.png"
import ChampionStudent from "../assets/champion-2024.png";
import AKTHEChampionStudent from "../assets/Akthe_Champions_2025.png";
import IATChampionStudent from "../assets/IATChampionStudent_2025_new.jpg";
import Certificate2 from "../assets/certificate-2024juniorsenior.png";
// import Map from "../assets/map-2024.png";
import Map from "../assets/map2026.jpg"
import Map2 from "../assets/map2.png";
import Certificate from "../assets/certificate-2025.png";
import ParticipateCertificate from "../assets/participation.png";
import ParticipateCertificate2 from "../assets/participationjuniorsenior.jpg";
import AKTHECertificate from "../assets/Akthe_excellence_2025.png";
import AKTHEParticipateCertificate from "../assets/Akthe_certificate_not_qualified.png";
import IacstAppear from "../assets/iacstappear-2023.png";
import Iacsttakeaakash from "../assets/iacsttake-2023.png";
import AntheHallframe from "../assets/Anthe-hall-winners-2024.png";
import AktheHallframe from "../assets/Akthe_hall_fame_2025.png";
import AnthePerformanceCard from "./Result/AntheResults/resultTable/anthePerformanceCard";
import CenterQRcode from "../assets/QR-code-center-2024.png";
import AKTHECenterQRcode from "../assets/AKthe_qrcode.png";
import AntheResultPage1_NotQualified from "./AntheResultPage1_NotQualified";
import ScoreCardTable from "./Result/AntheResults/resultTable/score-card-table";
import AntheResultPage2 from "./AntheResultPage2";
import EarlyAdmissionBenefit from "./EarlyAdmissionBenefit";
import config from "../config";
import imageSrc from "../assets/bg-pdf.png";
import aktheBg from "../assets/Akthe_bg.png";
import IacstPage from "./IacstPage";
import Invictuspage from "./InvictusResultPage";
import QRCode from "./QRCode";
function PDFGeneratorComponent({
  Response,
  isQualified,
  decodedData,
  loader,
  setLoader,
  setErrorPage,
  allowRender,
}) {
  const [isStudentPDF, setIsStudentPDF] = useState(true);
  const [isReqFromApi, setIsReqFromApi] = useState(
    decodedData?.req_from_api || false
  );
  const qr = Response?.centerData?.center_detail?.qr_code;

  useEffect(() => {
    if (decodedData?.admin && decodedData?.admin == "true")
      setIsStudentPDF(false);
  }, [decodedData]);

  useEffect(() => {
    if (decodedData?.req_from_api && decodedData?.req_from_api == "true")
      setIsReqFromApi(true);
  }, [decodedData]);

  const uploadPDF = async (pdf) => {
    if (!isReqFromApi) {
      const pdfBlob = pdf.output("blob");
      const formData = new FormData();
      formData.append("fileUpload", pdfBlob, "multi_page_pdf.pdf");
      formData.append("student_dob", decodedData.date_of_birth);
      formData.append("roll_number", decodedData.roll_no);

      if (decodedData?.admin) {
        formData.append("is_admin", decodedData?.admin);
      } else formData.append("is_admin", false);

      try {
        const response = await fetch(config.PDF_UPLOAD_API, {
          method: "POST",
          body: formData,
        });

        if (!response.ok) {
          throw new Error(`Request failed with status: ${response.status}`);
        }

        const data = await response.json();
        if (data.success) {
          setLoader(false);
          let resultUrl = data.data.result_url;
          window.open(resultUrl, "_self");
          // window.open(resultUrl, "_blank");
        }
      } catch (error) {
        // pdf.save("antheResult.pdf");
        let resObj = {
          "roll number": decodedData.roll_number,
          exam_type: decodedData.exam_type,
          class_studying: Response.profile.class_opted,
          stream: Response.profile.stream,
          state: Response.profile.state,
          branchCode: Response.profile.branch_id,
        };

        window.webengage.track(
          `${decodedData.exam_type}_db_main_result_student_view_error`,
          resObj
        );

        setLoader(false);
        // setErrorPage(true);
        console.error("Error uploading PDF:", error);
      }
    } else {
      setLoader(false);
    }
  };

  const [isGenerateCalled, setIsGenerateCalled] = useState(false);

  // Global cache for images
  const imageCache = {};
  // Preload and replace image sources with base64
  const preloadAndReplaceImages = async () => {
    const imageElements = document.querySelectorAll("img");
    const promises = Array.from(imageElements).map(async (img) => {
      const src = img.src;
      // Check if the image is already base64
      if (!src.startsWith("data:")) {
        const cachedImage = await loadImage(src);
        img.src = cachedImage; // Replace img.src with base64(cached) version
      }
    });

    await Promise.all(promises);
  };

  // Load and cache image, convert to base64
  const loadImage = async (src) => {
    if (imageCache[src]) {
      return imageCache[src]; // Return cached base64 if available
    }
    // Create an image object and load it
    const image = new Image();
    image.src = src;
    image.crossOrigin = "anonymous";
    await new Promise((resolve) => {
      image.onload = resolve;
      image.onerror = resolve;
    });
    // Convert image to base64 using a canvas
    const canvas = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(image, 0, 0);
    const dataUrl = canvas.toDataURL("image/png");
    imageCache[src] = dataUrl; // Cache base64 result
    return dataUrl;
  };

  const generatePDF = async () => {

    if (isReqFromApi || (decodedData?.exam_type !== "IAT" && decodedData?.exam_type !== "iACST" && decodedData?.exam_type !== "AKTHE")) return;

    await preloadAndReplaceImages();

    const pdf = new jsPDF();

    // Create an array to hold promises for each section
    const promises = [];
    const contentSections = document.querySelectorAll(".content-section");

    const bgImage = await loadImage(decodedData?.exam_type === "iACST" ? aktheBg : imageSrc); // Load background image once
    const aktheBgImage = await loadImage(aktheBg);
    const pageHeight = pdf.internal.pageSize.getHeight();
    const pdfWidth = pdf.internal.pageSize.getWidth();

    for (let i = 0; i < contentSections.length; i++) {

      const section = contentSections[i];

      // Add class to force desktop view styles
      section.classList.add("desktop-view");

      const canvas = await html2canvas(section, {
        scale: 2,
        compress: true,
        putOnlyUsedFonts: true,
      });

      const imgData = canvas.toDataURL("image/jpeg", 0.3);
      const imgProps = pdf.getImageProperties(imgData);

      // const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

      decodedData?.exam_type === "iACST" && pdf.addImage(
        bgImage,
        "png",
        0,
        0,
        pdfWidth,
        pageHeight,
        `bg-img`,
        "FAST"
      );
      if (decodedData?.exam_type === "IAT") {
        // Set background color (e.g., light pink)
        pdf.setFillColor(0, 66, 141); // RGB for #fbe8e8
        pdf.rect(0, 0, pdfWidth, pageHeight, "F"); // Fill full page with color
      } else if (decodedData?.exam_type === "AKTHE") {
        // Set background image for AKTHE
        pdf.addImage(
          aktheBgImage,
          "png",
          0,
          0,
          pdfWidth,
          pageHeight,
          `Akthe_bg`,
          "FAST"
        );
      } else if (decodedData?.exam_type === "ANTHE") {
        // Set background image
        pdf.addImage(
          bgImage,
          "png",
          0,
          0,
          pdfWidth,
          pageHeight,
          `bg-img`,
          "FAST"
        );
      }
      if (i === 0 && decodedData?.exam_type === "AKTHE") {
        pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth - 0, pageHeight - 15);
      } else {
        pdf.addImage(imgData, "JPEG", 7.5, 7.5, pdfWidth - 15, pageHeight - 15);
      }
      // Add image to cover full PDF page
      if (i < contentSections.length - 1) {
        pdf.addPage();
      }

      // Remove the added class
      section.classList.remove("desktop-view");

      // Push a promise for each section's rendering
      promises.push(
        new Promise((resolve) => {
          canvas.toBlob(resolve);
        })
      );
    }

    // Wait for all section rendering promises to resolve
    await Promise.all(promises);

    //file save on file size check
    if (pdf.output().length > 1000000) {
      pdf.save(`${decodedData?.exam_type || "anthe"}-result.pdf`);
      setIsGenerateCalled(false);
    } else generatePDF();

    // Upload the PDF after it's generated
    // await uploadPDF(pdf);
  };

  /* useEffect(() => {
    setTimeout(() => {
      isGenerateCalled && generatePDF();
    }, 250);
  }, [isGenerateCalled]); */

  //generating and uploading pdf
  /* useEffect(() => {
    if (document.querySelectorAll(".content-section").length > 4) {
      setIsGenerateCalled(true);
    }
  }, [document.querySelectorAll(".content-section")]); */

  const IATOlympiadsSection = (
    <div className="content-section p-4 full_page">
      <div className="">
        <div style={{ textAlign: "center", width: "100%", paddingTop: "20px" }}>
          <h2
            style={{
              fontFamily: "Outfit , sans-serif",
              fontWeight: 800,
              fontSize: "60px",
              color: "#009CDE",
              marginBottom: "10px",
              marginTop: 0,
              lineHeight: "120%",
            }}
          >
            Aakashians Create History in
            <br />
            International Olympiads
          </h2>

          <p
            style={{
              fontFamily: "Poppins, sans-serif",
              fontWeight: 550,
              fontSize: "37px",
              color: "#000",
              marginTop: "0px",
              marginBottom: "25px",
            }}
          >
            (Classroom Program Students)
          </p>
        </div>

        <img
          src={IATOlympiads}
          style={{ width: "95%", height: "50%" }}
          className="mx-auto d-flex"
          alt="IAT Olympiads"
        />
      </div>
    </div>
  );
  return (
    <>
      {allowRender && (
        <div id="myPdf">
          {Object.keys(Response).length > 0 && (
            <div>
              {decodedData?.exam_type === "IAT" || decodedData?.exam_type === "iACST" || decodedData?.exam_type === "AKTHE" || decodedData?.exam_type === "ANTHE" ? (
                <button
                  onClick={() => {

                    if (!isGenerateCalled) generatePDF();
                    setIsGenerateCalled(true);
                  }}
                >
                  {!isGenerateCalled
                    ? "Generate PDF"
                    : "Generating PDF, Please wait..."}
                </button>
              ) : (
                <></>
              )}
              <div className="content-section pb-3">
                <div className="">
                  {decodedData?.exam_type === "iACST" ? (
                    <IacstPage isQualified={isQualified} Response={Response} />
                  ) : decodedData?.exam_type === "IAT" ? (
                    <Invictuspage isQualified={isQualified} Response={Response} />
                  ) : isQualified ? (
                    <AntheResultPage1_Qualified
                      Response={Response}
                      isStudentPDF={isStudentPDF}
                    />
                  ) : (
                    <AntheResultPage1_NotQualified
                      Response={Response}
                      isStudentPDF={isStudentPDF}
                    />
                  )}
                </div>
              </div>

              {!isQualified && decodedData.exam_type !== "iACST" && decodedData.exam_type !== "IAT" && (
                <div className="content-section pb-4">
                  <div className="mx-5 mt-2">
                    <div
                      className="iacst-section"
                      style={{ height: "160px" }}
                    ></div>
                    <img
                      src={IacstAppear}
                      style={{ width: "100%" }}
                      className="mx-auto d-flex img-fluid mb-5"
                      alt="" />
                    <img
                      src={Iacsttakeaakash}
                      style={{ width: "100%" }}
                      className="mx-auto d-flex img-fluid mb-5"
                      alt="" />
                    <div className="dashed-border w-100 mx-auto rounded-20 p-3 mt-5">
                      {decodedData.exam_type === "AKTHE" ? (
                        <img
                          src={AktheHallframe}
                          style={{ width: "100%" }}
                          className="mx-auto d-flex img-fluid"
                          alt="AKTHE Hall of Fame"
                        />
                      ) : (
                        <>
                          <h2 className="text-center text-light-blue-100 font-size-60 mb-4">
                            Hall of Fame
                          </h2>
                          <img
                            src={AntheHallframe}
                            style={{ width: "100%" }}
                            className="mx-auto d-flex img-fluid"
                            alt="Hall of Fame"
                          />
                        </>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {(decodedData.exam_type === "IAT" || decodedData.exam_type === "iACST") && (
                <div className="content-section p-4 mt-4 full_page">
                  <div className="">
                    <EarlyAdmissionBenefit
                      exam_type={decodedData.exam_type}
                      class_studying={Response.profile.class_studying}
                      style={{ width: "100%" }}
                      className="mt-3 mb-2"
                      Response={Response}
                      Qualifycheck={isQualified}
                    />
                  </div>
                </div>
              )}
              {!isQualified && isStudentPDF ? null : (
                <div className="content-section p-4 full_page">
                  <div className="">
                    <AntheResultPage2 Response={Response} exam_type={decodedData.exam_type} />
                    <ScoreCardTable
                      Response={Response}
                      scoreCard={Response.score_metrics}
                      exam_type={decodedData.exam_type}
                    />{" "}
                    <div id="cardData115" className="mt-3 p-4">
                      <AnthePerformanceCard
                        exam_type={decodedData.exam_type}
                        renderTo="cardData115"
                        Response={Response}
                      />
                    </div>
                  </div>
                </div>
              )}
              {!isQualified && isStudentPDF ? null : (
                <div className="content-section full_page p-4">
                  <div className="page-between">
                    <AntheComplexTable data={Response} exam_type={decodedData.exam_type} />
                  </div>
                  {(decodedData.exam_type !== "IAT" && (decodedData.exam_type === "ANTHE" || decodedData.exam_type === "AKTHE")) && (
                    <div
                      className="d-flex w-10 justify-content-end align-items-center "
                      style={{ padding: "0px 40px", marginTop: "90px" }}
                    >
                      <div>
                        {decodedData.exam_type === "AKTHE" ? (
                          <p className="fw-bold font-size-xxl">
                            Visit your nearest centre for academic counseling,
                            <br /> personalized expert guidance & scholarship/ fee details.
                          </p>
                        ) : (
                          <p className="fw-bold font-size-xxl">
                            Visit your nearest branch for academic counseling,
                            <br />  personalized expert guidance & scholarship/ fee details.
                          </p>
                        )}
                      </div>
                      <div className="w-3">
                        {decodedData.exam_type === "AKTHE" ? (
                          <img style={{ width: "45%" }} src={AKTHECenterQRcode} alt="" />
                        ) : (
                          <img style={{ width: "45%" }} src={CenterQRcode} alt="" />
                        )}
                        {decodedData.exam_type === "AKTHE" ? (
                          <p
                            className="font-size-sm mt-0 fw-bold"
                            style={{ padding: "0px 63px" }}
                          >
                            Scan the QR code and
                            get the centre location
                            in your Google Maps{" "}
                          </p>
                        ) : (
                          <p>
                            Scan the QR code and
                            get the branch location
                            in your Google Maps{" "}
                          </p>
                        )}
                      </div>

                    </div>
                  )}
                </div>
              )}
              {!isQualified && isStudentPDF ? null : (
                <div className="content-section full_page p-4">
                  <div className="page-between">
                    <RelativePerformanceTable data={Response} exam_type={decodedData.exam_type} />
                  </div>

                  {(decodedData.exam_type !== "IAT" && (decodedData.exam_type === "ANTHE" || decodedData.exam_type === "AKTHE")) && (
                    <div
                      className="d-flex w-10 justify-content-end align-items-center "
                      style={{ padding: "0px 40px", marginTop: "90px" }}
                    >
                      <div>
                        {decodedData.exam_type === "AKTHE" ? (
                          <p className="fw-bold font-size-xxl">
                            Visit your nearest centre for academic counseling,
                            <br /> personalized expert guidance & scholarship/ fee details.
                          </p>
                        ) : (
                          <p className="fw-bold font-size-xxl">
                            Visit your nearest branch for academic counseling,
                            <br />  personalized expert guidance & scholarship/ fee details.
                          </p>
                        )}
                      </div>
                      <div className="w-3">
                        {decodedData.exam_type === "AKTHE" ? (
                          <img style={{ width: "45%" }} src={AKTHECenterQRcode} alt="" />
                        ) : (
                          <img style={{ width: "45%" }} src={CenterQRcode} alt="" />
                        )}
                        {decodedData.exam_type === "AKTHE" ? (
                          <p
                            className="font-size-sm mt-0 fw-bold"
                            style={{ padding: "0px 63px" }}
                          >
                            Scan the QR code and
                            get the centre location
                            in your Google Maps{" "}
                          </p>
                        ) : (
                          <p>
                            Scan the QR code and
                            get the branch location
                            in your Google Maps{" "}
                          </p>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* <div className="content-section" id="cardData115"></div> */}
              {isQualified && (
                decodedData.exam_type === "AKTHE" ? (
                  <div className="content-section p-4 full_page">
                    <div className="">
                      <img
                        src={AKTHECashAward}
                        width={"100%"}
                        className="mx-auto d-flex w-100"
                        alt="AKTHE Cash Awards"
                      />
                    </div>
                  </div>
                ) : (
                  decodedData.exam_type !== "iACST" && decodedData.exam_type !== "IAT" && (
                    <div className="content-section p-4 full_page">
                      <div className="">
                        <img
                          src={CashAwards}
                          width={"94%"}
                          className="mx-auto d-flex w-90"
                          alt="Cash Awards"
                        />
                      </div>
                    </div>
                  )
                )
              )}
              <div className="content-section p-4 pt-2 full_page pb-5">
                <div className="">
                  <p
                    style={{
                      color: "#2B7DCA",
                      fontFamily: "Outfit , sans-serif",
                      fontSize: "65px",
                      marginBottom: "0px",
                      marginTop: "10px",
                      letterSpacing: "1.2px",
                    }}
                  >

                    {decodedData.exam_type === "IAT" || decodedData.exam_type === "ANTHE"
                      ? null
                      : <b>AAKASH ADVANTAGE </b>
                    }
                  </p>
                  {decodedData.exam_type === 'IAT' ? (
                    <div
                      className="w-100"
                      style={{
                        height: '100vh',
                        display: 'flex',
                        flexDirection: 'column',
                        background: '#fff',
                      }}
                    >
                      {/* IMAGE AREA */}
                      <div
                        style={{
                          flex: 1,
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          padding: '16px',
                          boxSizing: 'border-box',
                        }}
                      >
                        <img
                          src={IATBiggerAdvantage}
                          alt=""
                          style={{
                            width: '100%',
                            maxHeight: '90%', //  image reduced by ~15%
                            objectFit: 'contain',
                          }}
                        />
                      </div>

                      {/* FOOTER / QR AREA */}
                      {qr && (
                        <div
                          style={{
                            height: '170px', // MUST be >= QRCode height (150px)
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'flex-end',
                            padding: '8px 12px',
                            boxSizing: 'border-box',
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px',
                            }}
                          >
                            {/* TEXT */}
                            <div
                              style={{
                                fontSize: '13px',
                                color: '#333',
                                textAlign: 'right',
                                lineHeight: '1.3',
                                fontWeight: 60
                              }}
                            >
                              For detailed information visit your nearest branch.
                            </div>

                            {/* QR */}
                            <QRCode
                              qr={qr}
                              vertical={true}
                              infoTip="Scan the QR code and get the branch location in your Google Maps"
                            />
                          </div>
                        </div>
                      )}
                    </div>

                  ) : decodedData.exam_type === 'AKTHE' ? (
                    <img
                      src={AKTHEBiggerAdvantage}
                      width="85%"
                      className="mx-auto d-flex w-100 mt-4 pb-3"
                      alt=""
                    />
                  ) : decodedData.exam_type === 'iACST' ? (
                    <div style={{ position: 'relative' }}>
                      <img
                        src={iACSTBiggerAdvantage}
                        width={"85%"}
                        height={'85%'}
                        className="mx-auto d-flex mt-0 pb-3" alt=""
                      />
                      {qr && (
                        <div style={{ position: 'absolute', right: 12, bottom: '-20px', bottom: '-120px' }}>
                          <QRCode qr={qr} vertical={true} infoTip="Scan the QR code and get the branch location in your Google Maps" />
                        </div>
                      )}
                    </div>
                  ) : (<img
                    src={AKTHEBiggerAdvantage}
                    width={"85%"}
                    className="mx-auto d-flex w-100 mt-0 pb-3" alt=""
                  />)}
                </div>
              </div>
              {decodedData.exam_type === "IAT" && (
                <div className="content-section p-4 full_page">

                  {/* Title Section */}
                  <div
                    style={{
                      color: "#009CDE",
                      width: "100%",
                      textAlign: "center",
                      padding: "30px 0 20px 0",
                    }}
                  >
                    <h6
                      style={{
                        fontFamily: "Outfit , sans-serif",
                        fontWeight: 700,
                        fontSize: "78px",
                        lineHeight: "110%",
                        color: '#009CDE',
                        margin: 0,
                      }}
                    >
                      Outstanding Result in
                    </h6>
                  </div>

                  {/* Image Section */}
                  <div style={{ marginTop: "10px", textAlign: "center" }}>
                    <img
                      src={IAT_OUTSTANDING}
                      alt="IAT New Page"
                      style={{
                        width: "100%",
                        height: "90%",
                      }}
                    />
                  </div>

                </div>
              )}
              {decodedData.exam_type === "IAT" && IATOlympiadsSection}
              {decodedData.exam_type === "IAT" && (
                <div className="content-section p-4 full_page">
                  <div className="">
                    {decodedData.exam_type === "IAT" && (
                      <div style={{ textAlign: "center", padding: "20px 0" }}>
                        <h2
                          style={{
                            fontFamily: "Outfit , sans-serif",
                            fontWeight: 700,
                            fontSize: "62px",
                            color: "#009CDE",
                            margin: 0,
                            lineHeight: "120%",
                            paddingBottom: "4%",
                            paddingTop: "2%"
                          }}
                        >
                          JEE Advanced 2025 Result
                        </h2>
                      </div>
                    )}
                    <img
                      src={IATResultGraph}
                      className="mx-auto d-flex w-100"
                      alt="champion"
                      style={{
                        height: "71%",
                        objectFit: "contain"
                      }}
                    />
                  </div>
                </div>

              )}
              <div className="content-section p-4 full_page">
                <div>
                  {decodedData.exam_type === "IAT" && (
                    <div style={{ textAlign: "center", padding: "20px 0" }}>
                      {/* MASTER WRAPPER */}
                      <div style={{ display: "inline-flex", flexDirection: "column", alignItems: "center" }}>

                        <h2
                          style={{
                            fontFamily: "Outfit, sans-serif",
                            fontWeight: 700,
                            fontSize: "76px",
                            color: "#009CDE",
                            margin: 0,
                            lineHeight: "1",
                            whiteSpace: "nowrap",
                          }}
                        >
                          NEET (UG) 2025
                        </h2>

                        {/* DOTTED LINE – WILL ALWAYS SHOW */}
                        <div
                          style={{
                            width: "100%",          // takes h2 width
                            borderBottom: "4px dotted #000",
                            marginTop: "12px",
                          }}
                        />

                        <p
                          style={{
                            fontFamily: "Outfit, sans-serif",
                            fontWeight: 500,
                            fontSize: "70px",
                            color: "#000",
                            margin: "16px 0 0 0",
                            lineHeight: "1",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Champions Again!
                        </p>

                      </div>
                    </div>

                  )}

                  {decodedData.exam_type === "AKTHE" ? (
                    <img
                      src={AKTHEChampionStudent}
                      className="mx-auto d-flex w-100"
                      alt="champion"
                    />
                  ) : decodedData.exam_type === "IAT" ? (
                    <img
                      src={IATChampionStudent}
                      className="mx-auto d-flex"
                      style={{
                        width: '95%',
                        height: '95%',
                        objectFit: 'contain'
                      }}
                    />
                  ) : (
                    <img
                      src={AKTHEChampionStudent}
                      className="mx-auto d-flex w-100"
                      alt="champion"
                    />
                  )}
                </div>
              </div>
              {decodedData.exam_type !== 'IAT' && (<div className="content-section p-4 full_page">
                <div className="">

                  {decodedData.exam_type === "IAT" && (
                    <div style={{ textAlign: "center", padding: "20px 0" }}>
                      <h2
                        style={{
                          fontFamily: "Outfit , sans-serif",
                          fontWeight: 700,
                          fontSize: "62px",
                          color: "#009CDE",
                          margin: 0,
                          lineHeight: "120%",
                          paddingBottom: "4%",
                          paddingTop: "2%"
                        }}
                      >
                        JEE Advanced 2025 Result
                      </h2>
                    </div>
                  )}
                  {decodedData.exam_type === "AKTHE" ? (
                    <img
                      src={AktheOustandingresult}
                      className="mx-auto d-flex w-100"
                      alt="AKTHE Result"
                    />
                  ) : (
                    <img
                      src={AktheOustandingresult}
                      style={{ width: "100%" }}
                      className="mx-auto d-flex w-90"
                      alt="result"
                    />
                  )}
                  {/* {decodedData.exam_type === "IAT" ? (
                    <img
                      src={IATResultGraph}
                      className="mx-auto d-flex w-100"
                      alt="champion"
                      style={{
                        height: "71%",
                        objectFit: "contain"
                      }}
                    />
                  ) : decodedData.exam_type === "AKTHE" ? (
                    <img
                      src={AktheOustandingresult}
                      className="mx-auto d-flex w-100"
                      alt="AKTHE Result"
                    />
                  ) : (
                    <img
                      src={AktheOustandingresult}
                      style={{ width: "100%" }}
                      className="mx-auto d-flex w-90"
                      alt="result"
                    />
                  )} */}

                </div>
              </div>)}

              {(decodedData.exam_type === 'iACST' || decodedData.exam_type === 'AKTHE' || decodedData.exam_type === 'ANTHE') && (
                <>
                  {!decodedData.exam_type === 'iACST' && <div className="content-section p-4 full_page">
                    <div className="">
                      {(decodedData.exam_type === 'AKTHE' || decodedData.exam_type === 'ANTHE') ? (
                        <img
                          src={AktheOustandingresultAdv}
                          className="mx-auto d-flex w-100"
                          alt="AKTHE Result"
                        />
                      ) : null}
                    </div>
                  </div>}
                  <div className="content-section p-4 full_page"
                    style={{ marginBottom: (decodedData.exam_type === 'AKTHE' || decodedData.exam_type === 'ANTHE') ? "50px" : "0" }}>
                    <div>
                      {(decodedData.exam_type === 'iACST' || decodedData.exam_type === 'AKTHE' || decodedData.exam_type === 'ANTHE') ? (
                        <img
                          src={AktheOlympiads1}
                          className="mx-auto d-flex"
                          alt="AKTHE Result"
                          style={{ width: "88%" }}
                        />
                      ) : null}
                    </div>
                  </div>
                </>
              )}
              {decodedData.exam_type !== 'IAT' && <div className="content-section p-4 full_page">
                <div className="">

                  {/* Show Title + Subtitle ONLY for IAT */}
                  {/* {decodedData.exam_type === "IAT" && (
                    <div style={{ textAlign: "center", width: "100%", paddingTop: "20px" }}>

                      <h2
                        style={{
                          fontFamily: "Outfit , sans-serif",
                          fontWeight: 800,
                          fontSize: "60px",
                          color: "#009CDE",
                          marginBottom: "10px",
                          marginTop: 0,
                          lineHeight: "120%"
                        }}
                      >
                        Aakashians Create History in
                        <br />
                        International Olympiads
                      </h2>

                      <p
                        style={{
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: 550,
                          fontSize: "37px",
                          color: "#000",
                          marginTop: "0px",
                          marginBottom: "25px"
                        }}
                      >
                        (Classroom Program Students)
                      </p>
                    </div>
                  )} */}

                  {/* IMAGE SECTION */}
                  {decodedData.exam_type === "AKTHE" ? (
                    <img
                      src={AktheOlympiads2}
                      style={{ width: "80%" }}
                      className="mx-auto d-flex w-90"
                      alt=""
                    />
                  ) : (
                    <img
                      src={AktheOlympiads2}
                      style={{ width: "88%" }}
                      className="mx-auto d-flex w-90"
                      alt=""
                    />
                  )}
                  {/* {decodedData.exam_type === "IAT" ? (
                    <img
                      src={IATOlympiads}
                      style={{
                        width: "95%",
                        height: "50%"
                      }}
                      className="mx-auto d-75 w-80"
                      alt=""
                    />
                  ) : decodedData.exam_type === "AKTHE" ? (
                    <img
                      src={AktheOlympiads2}
                      style={{ width: "80%" }}
                      className="mx-auto d-flex w-90"
                      alt=""
                    />
                  ) : (
                    <img
                      src={AktheOlympiads2}
                      style={{ width: "88%" }}
                      className="mx-auto d-flex w-90"
                      alt=""
                    />
                  )} */}

                </div>
              </div>}


              {decodedData.exam_type === "AKTHE" ? (
                <div className="content-section p-4 full_page">
                  <div className="">
                    <img
                      src={AKTHETripWinner}
                      style={{ width: "100%" }}
                      className="mx-auto d-flex w-90"
                      alt=""
                    />
                  </div>
                </div>
              ) : decodedData.exam_type !== "iACST" && decodedData.exam_type !== "IAT" ? (
                <div className="content-section p-4 full_page">
                  <div className="">
                    <img
                      src={AKTHETripWinner}
                      style={{ width: "100%" }}
                      className="mx-auto d-flex w-90"
                      alt=""
                    />
                  </div>
                </div>
              ) : (
                ""
              )}
              {/* {decodedData.exam_type !== "AKTHE" && decodedData.exam_type !== "ANTHE"? (
            <div className="content-section p-4 full_page">
              <div className="">
                {!Response.profile.anthetwo ? (
                  <img src={Map} className="mx-auto d-flex w-100" />
                ) : (
                  <img src={Map2} className="mx-auto d-flex w-100" />
                )}
              </div>
            </div>
          ) : null} */}
              {decodedData.exam_type === 'IAT' && (
                <div className="content-section p-4 full_page">
                  <div className="">
                    <img src={Map2} className="mx-auto d-flex w-100" alt="map2" />
                  </div>
                </div>
              )}

              {decodedData.exam_type == "iACST" && (
                <div className="content-section p-4 full_page">
                  <div className="">
                    {!Response.profile.anthetwo ? (
                      <img src={Map} className="mx-auto d-flex w-100" alt="map" />
                    ) : (
                      <img src={Map2} className="mx-auto d-flex w-100" alt="map2" />
                    )}
                  </div>
                </div>
              )}
              {decodedData.exam_type !== "iACST" && decodedData.exam_type !== "IAT" && decodedData.exam_type !== "AKTHE" ? (
                <div className="content-section p-0" style={{ position: "relative" }}>
                  <div className="">
                    <div className="certificate-name akthe_certificate">
                      <p className="text-light font-size-45 fw-bold">
                        {Response.profile.name}
                      </p>
                    </div>
                    {!Response.profile.anthetwo ? (
                      <img
                        src={isQualified ? Certificate : ParticipateCertificate}
                        width={1600}
                        className="mx-auto d-flex img-fluid w-100"
                      />
                    ) : (
                      <img
                        src={isQualified ? Certificate2 : ParticipateCertificate2}
                        width={1600}
                        className="mx-auto d-flex img-fluid w-100"
                      />
                    )}
                  </div>
                </div>
              ) : decodedData.exam_type === "AKTHE" ? (
                <div className="content-section p-0" style={{ position: "relative" }}>
                  <div className="">
                    <div className="certificate-name akthe_certificate">
                      <p className="text-light font-size-45 fw-bold">
                        {Response.profile.name}
                      </p>
                    </div>
                    <img
                      src={isQualified ? AKTHECertificate : AKTHEParticipateCertificate}
                      width={1600}
                      className="mx-auto d-flex img-fluid w-100"
                    />
                  </div>
                </div>
              ) : null}
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default PDFGeneratorComponent;
